import React, { Component } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class VigenciaRenovacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAlert: false,
        };
        this.changeInput = this.changeInput.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("VIGENCIA_RENOVACION", event.target.value.replace(/\./g, ''));
    }

    ShowAlert(event) {
        this.setState({ showAlert: true });
    }

    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;

        let errorContainer;

        errorContainer = <label className="error">
            {(errors = getFieldError('inputVigenciaRenovacion')) ?
                this.props.form.isFieldTouched("inputVigenciaRenovacion") ?
                    errors.join(',') : null
                : null}</label>

        let inputVigenciaDesdeLaRenovacion = undefined;

        if (this.props.data != undefined && this.props.data != "") {
            let tiposEmpresa = this.props.data.GET_TIPOS_EMPRESA;
            if (tiposEmpresa.length > 0) {

                inputVigenciaDesdeLaRenovacion =
                    <div className="col-xs-6">
                        <div>
                            <label className="label-primary">Vigencia desde la renovación</label>
                        </div>
                        <div>
                            <div className="row">
                                <div className="col-xs-6">
                                    <GenericInputValidate
                                        getFieldProps={getFieldProps('inputVigenciaRenovacion', {
                                            onChange(e) {
                                                me.changeInput(e);
                                            },
                                            rules: [{
                                                required: true,
                                                pattern: /^[1-9]+$/,
                                                message: 'Debe ingresar un valor válido.'
                                            }]
                                        })}
                                        id="inputVigenciaRenovacion"
                                        name="inputVigenciaRenovacion"
                                        value={this.props.data.VigenciaDesdeLaRenovacion}
                                        className="form-control default-input"
                                        maxLength="1"
                                    />
                                </div>

                                <div className="col-xs-6">
                                    <label className="label-secondary"> años</label>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    {errorContainer}
                                </div>
                            </div>
                        </div>
                    </div>;
            }
        }

        return (
            <div>{inputVigenciaDesdeLaRenovacion}</div>
        );
    }
};

export default VigenciaRenovacion;